import type React from 'react';
import StatCard from './StatCard';

interface DashboardCardProps {
  name: string;
  header: string;
  subHeader: string;
  children?: React.ReactNode;
  className?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ name, header, subHeader, children, className }) => (
  <StatCard className={className}>
    <div className='flex flex-col w-full'>
      <span className='text-base font-medium'>{name}</span>
      <span className='text-2xl font-bold text-neutralColor-darkest'>{header}</span>
      <span className='text-xs text-neutralColor-normal'>{subHeader}</span>
      {children && <div className='mt-2'>{children}</div>}
    </div>
  </StatCard>
);

export default DashboardCard;
